import { IonContent, IonHeader, IonPage, IonToolbar } from "@ionic/react";
import Header from "../components/layout/Header";

const LocalhostIframe = () => {
  return (
    <IonPage>
      <IonHeader mode="ios">
        <Header />
      </IonHeader>
      <IonContent>
        <div
          style={{
            width: "100%",
            height: "100vh",
            position: "relative",
          }}
        >
          <iframe
            src="https://exams.loonlog.ca"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
            title="Exams"
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default LocalhostIframe;

